import { get } from 'react-hook-form';
import apiClient from './api/client';
import ENDPOINTS from './api/endpoints';
import qs from 'qs';  // install with `npm install qs` for robust serialization
/**
 * table layout Service
 * Handles all server side table related API calls
 */

export const serverSideTableService = {
    fetchTableLayout: async (tableName) => {
            try {
                const response = await apiClient.get(ENDPOINTS.TABLE_LAYOUT.GET_BY_NAME(tableName));
                return response;
            } catch (error) {
                console.error(`Failed to fetch table layout for ${tableName}:`, error);
                throw error;
            }
        },
    fetchTableData: async (endpoint, bodyParams) => {
                try {
                    const queryString = qs.stringify(bodyParams, { arrayFormat: 'repeat' });
                    const url = `${ENDPOINTS.FETCH_DATA.GET_ALL(endpoint)}?${queryString}`;
                    const response = await apiClient.get(url);
                    return response;
                } catch (error) {
                    console.error(`Failed to fetch data from ${endpoint}:`, error);
                    throw error;
                }
                },

    fetchBillItems: async (billId) => {
        try {
            const response = await apiClient.get(ENDPOINTS.BILLS.GET_ITEMS(billId));
            return response;
        } catch (error) {
            console.error(`Failed to fetch bill items for bill ${billId}:`, error);
            throw error;
        }
    },

    fetchBillPayments: async (billId) => {
        try {
            const response = await apiClient.get(ENDPOINTS.BILLS.GET_PAYMENTS(billId));
            return response;
        } catch (error) {
            console.error(`Failed to fetch bill payments for bill ${billId}:`, error);
            throw error;
        }
    },
}